import { useEffect, useRef, useState } from 'react'

import IconButton from 'components/IconButton'

import CSATPopup from './components/CSATPopup'
import { useChartPrint } from '../../contexts/ChartPrintContext'
import { useOutsideClick } from '../../hooks'

import './index.scss'

interface IPrintButton {
  chartTitle: string
  dataUniverse?: string
  color?: string
  disabled?: boolean
  onPrint?: () => void
  onExport?: (exportType?: string, chartTitle?: string) => void | Promise<void>
}

export default function PrintButton({
  chartTitle,
  dataUniverse,
  color = 'var(--color_primary_500)',
  disabled,
  onPrint,
  onExport,
}: IPrintButton) {
  const [isCsatOpen, setIsCsatOpen] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const ref = useRef(null)

  const { isClickOutside } = useOutsideClick(ref)
  const { getPrint, isPrinting } = useChartPrint()

  const onClick = async () => {
    if (onExport) {
      setIsExporting(true)
      try {
        await onExport('image/png', chartTitle)
      } finally {
        setIsExporting(false)
      }
      return
    }
    if (getPrint) {
      getPrint(chartTitle, dataUniverse)
      onPrint?.()
      return
    }
  }

  useEffect(() => {
    if (isClickOutside) {
      setIsCsatOpen(false)
    }
  }, [isClickOutside])

  return (
    <div className="PrintButton-wrapper" ref={ref}>
      <IconButton
        onClick={onClick}
        icon="camera"
        color={color}
        padding={8}
        className="PrintButton-button skipOnPrint"
        disabled={disabled || isPrinting || isExporting}
        aria-busy={isPrinting || isExporting}
      />
      {isCsatOpen && <CSATPopup closePopup={() => setIsCsatOpen(false)} />}
    </div>
  )
}
